import apisauce from 'apisauce'

const ApiUrls = {
  Local: `http://127.0.0.1:3001/`,
  Stage: 'https://yritystieto-api-staging.peanutsgroup.com/',
  Production: 'https://yritystieto-api.peanutsgroup.com/',
}

let ApiUrl = ApiUrls.Production
if (window.location.hostname.includes('staging.peanutsgroup.com')) {
  ApiUrl = ApiUrls.Stage
}
if (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1')) {
  ApiUrl = ApiUrls.Local
}

const create = (baseURL = ApiUrl) => {
  const api = apisauce.create({
    baseURL,
    headers: {
      apikey: '0tce8R0Qpm1qICPuhq02oJqVdyZMghMBAqCrjyPF',
      "Content-Type": "application/json",
    },
    timeout: 15000,
  })

  const searchByValue = async (searchstring, filters) =>
    api.get(`widgets/search/${searchstring}`, { ...filters })

  const getRegionStatistics = async (region, industry, year) =>
    api.get("widgets/region-info", { region, industry, year })

  const getCompany = async businessId => api.get(`companies/${businessId}`)
  const getBranch = async branchId => api.get(`branches/${branchId}`)
  const getSearchFilters = async () => api.get("widgets/search-filters")

  // Profinder industries
  const getProfinderIndustries = async () => api.get("companies/pf-industry-types")
  const getProfinderBranchIndustries = async () => api.get("branches/pf-industry-types")

  return {
    searchByValue,
    getRegionStatistics,
    getCompany,
    getBranch,
    getSearchFilters,
    getProfinderIndustries,
    getProfinderBranchIndustries,
  }
}

const Api = create()

export default Api
